/* eslint-disable @typescript-eslint/no-explicit-any */
export interface PurchaseOrder {
  purchaseOrderCode: string;
  purchaseOrderItemId: string;
}
export type Item = {
  numero_item: string;
  codigo_produto: string;
  codigo_barras_comercial: string;
  descricao: string;
  codigo_ncm: string;
  nves: [any];
  infos_credito_presumido: [any];
  cfop: string;
  unidade_comercial: string;
  quantidade_comercial: string;
  valor_unitario_comercial: string;
  valor_bruto: string;
  codigo_barras_tributavel: string;
  unidade_tributavel: string;
  quantidade_tributavel: string;
  valor_unitario_tributavel: string;
  inclui_no_total: string;
  documentos_importacao: [any];
  detalhes_exportacao: [any];
  rastros: [any];
  origens_combustivel: [any];
  icms_percentual_partilha: string;
  observacoes_contribuinte: [any];
  icms_origem: string;
  icms_situacao_tributaria: string;
  icms_modalidade_base_calculo: string;
  icms_base_calculo: string;
  icms_aliquota: string;
  icms_valor: string;
  pis_situacao_tributaria: string;
  pis_base_calculo: string;
  pis_aliquota_porcentual: string;
  pis_valor: string;
  cofins_situacao_tributaria: string;
  cofins_base_calculo: string;
  cofins_aliquota_porcentual: string;
  cofins_valor: string;
  purchaseOrder?: PurchaseOrder;
};

export type FormaPagamento = {
  indicador_pagamento: string;
  forma_pagamento: string;
  valor_pagamento: string;
  tipo_integracao: string;
};

export type Duplicata = {
  numero: string;
  data_vencimento: string;
  valor: string;
};

export type RequisicaoNotaFiscal = {
  versao: string;
  chave_nfe: string;
  uf: string;
  codigo_unico: string;
  natureza_operacao: string;
  modelo: string;
  serie: string;
  numero: string;
  data_emissao: string;
  data_entrada_saida: string;
  tipo_documento: string;
  local_destino: string;
  municipio: string;
  formato_impressao: string;
  forma_emissao: string;
  digito_verificador: string;
  ambiente: string;
  finalidade_emissao: string;
  consumidor_final: string;
  presenca_comprador: string;
  indicador_intermediario: string;
  processo_emissao: string;
  versao_aplicativo: string;
  notas_referenciadas: string;
  cnpj_emitente: string;
  nome_emitente: string;
  nome_fantasia_emitente: string;
  logradouro_emitente: string;
  numero_emitente: string;
  complemento_emitente: string;
  bairro_emitente: string;
  codigo_municipio_emitente: string;
  municipio_emitente: string;
  uf_emitente: string;
  cep_emitente: string;
  codigo_pais_emitente: string;
  telefone_emitente: string;
  inscricao_estadual_emitente: string;
  inscricao_municipal_emitente: string;
  cnae_fiscal_emitente: string;
  regime_tributario_emitente: string;
  cnpj_destinatario: string;
  nome_destinatario: string;
  logradouro_destinatario: string;
  numero_destinatario: string;
  complemento_destinatario: string;
  bairro_destinatario: string;
  codigo_municipio_destinatario: string;
  municipio_destinatario: string;
  uf_destinatario: string;
  cep_destinatario: string;
  codigo_pais_destinatario: string;
  pais_destinatario: string;
  telefone_destinatario: string;
  indicador_inscricao_estadual_destinatario: string;
  inscricao_estadual_destinatario: string;
  email_destinatario: string;
  cnpj_retirada: string;
  nome_retirada: string;
  logradouro_retirada: string;
  numero_retirada: string;
  bairro_retirada: string;
  codigo_municipio_retirada: string;
  municipio_retirada: string;
  uf_retirada: string;
  cep_retirada: string;
  telefone_retirada: string;
  inscricao_estadual_retirada: string;
  pessoas_autorizadas: [any];
  itens: [Item];
  icms_base_calculo: string;
  icms_valor_total: string;
  icms_valor_total_desonerado: string;
  fcp_valor_total: string;
  icms_base_calculo_st: string;
  icms_valor_total_st: string;
  fcp_valor_total_st: string;
  fcp_valor_total_retido_st: string;
  valor_produtos: string;
  valor_frete: string;
  valor_seguro: string;
  valor_desconto: string;
  valor_total_ii: string;
  valor_ipi: string;
  valor_ipi_devolvido: string;
  valor_pis: string;
  valor_cofins: string;
  valor_outras_despesas: string;
  valor_total: string;
  modalidade_frete: string;
  reboques: [any];
  volumes: [any];
  numero_fatura: string;
  valor_original_fatura: string;
  valor_desconto_fatura: string;
  valor_liquido_fatura: string;
  duplicatas: [Duplicata];
  formas_pagamento: [FormaPagamento];
  informacoes_adicionais_contribuinte: string;
  observacoes_contribuinte: [any];
  observacoes_fisco: [any];
  processos_referenciados: [any];
  cnpj_responsavel_tecnico: string;
  contato_responsavel_tecnico: string;
  email_responsavel_tecnico: string;
  telefone_responsavel_tecnico: string;
};

export type IInvoice = {
  itens: [Item];
  _id?: string;
  companyId: string;

  nome_emitente: string;
  documento_emitente: string;
  chave_nfe: string;
  valor_total: string;
  data_emissao: string;
  situacao: string;
  nfe_completa: boolean;
  tipo_nfe: string;
  versao: number;
  digest_value: string;
  cnpj_destinatario?: string;
  cpf_destinatario?: string;

  requisicao_nota_fiscal?: RequisicaoNotaFiscal;
  stock_launched?: boolean;
  purchase_order_launched: boolean;
};

export const emptyItem = () =>
  ({
    numero_item: "",
    codigo_produto: "",
    codigo_barras_comercial: "",
    descricao: "",
    codigo_ncm: "",
    nves: [{}],
    infos_credito_presumido: [{}],
    cfop: "",
    unidade_comercial: "",
    quantidade_comercial: "",
    valor_unitario_comercial: "",
    valor_bruto: "",
    codigo_barras_tributavel: "",
    unidade_tributavel: "",
    quantidade_tributavel: "",
    valor_unitario_tributavel: "",
    inclui_no_total: "",
    documentos_importacao: [{}],
    detalhes_exportacao: [{}],
    rastros: [{}],
    origens_combustivel: [{}],
    icms_percentual_partilha: "",
    observacoes_contribuinte: [{}],
    icms_origem: "",
    icms_situacao_tributaria: "",
    icms_modalidade_base_calculo: "",
    icms_base_calculo: "",
    icms_aliquota: "",
    icms_valor: "",
    pis_situacao_tributaria: "",
    pis_base_calculo: "",
    pis_aliquota_porcentual: "",
    pis_valor: "",
    cofins_situacao_tributaria: "",
    cofins_base_calculo: "",
    cofins_aliquota_porcentual: "",
    cofins_valor: "",
  } as Item);
